export default __webpack_public_path__ + "static/media/error_pa.bc070ef6.jpg";